<template>
  <div>
    <v-container>
      <v-row class="justify-center" style="padding-left: 10px">
        <v-container v-if="loading == true">
          <v-skeleton-loader
            :height="180"
            :max-width="350"
            type="card"
          ></v-skeleton-loader>
        </v-container>
        <v-container v-else>
          <v-card-text
            v-if="smp.length == 0"
            class="text-center"
            style="font-size: 20px"
            >No Data</v-card-text
          >
          <v-card v-else width="500">
            <HereMap
              :center="map(latitude[0], longitude[0])"
              v-if="renderComponent"
            />
          </v-card>
        </v-container>
      </v-row>

      <v-card-title>Alert</v-card-title>
      <div style="padding-left: 10px">
        <v-card>
          <v-card-text
            v-if="eventSeismic == 0 && eventSound == 0 && eventDensity == 0"
            class="text-center"
            style="font-size: 20px"
            >No Data</v-card-text
          >

          <v-simple-table v-else>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    #
                  </th>
                  <th class="text-left">
                    Date
                  </th>
                  <th class="text-left">
                    Time
                  </th>
                  <th class="text-left">
                    Description
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, idx) in event" :key="idx">
                  <td>{{ idx + 1 }}</td>
                  <td>
                    {{ formatDay(item.timestamp) }}
                    {{ formatMonth(item.timestamp) }}
                  </td>
                  <td>{{ formatTime(item.timestamp) }}</td>
                  <td>
                    {{
                      eventDesc(
                        item.fields.event_id,
                        item.fields.seismic_data.mag,
                        item.fields.seismic_data.angle,
                        item.fields.sound_data.sound,
                        item.fields.sound_data.evt_duration,
                        item.fields.air_quality_data.density,
                        item.fields.air_quality_data.co,
                        item.fields.air_quality_data.no2,
                        item.fields.air_quality_data.nh3,
                        item.fields.weather_data.amb_temp,
                        item.fields.weather_data.humidity
                      )
                    }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </div>

      <v-row style="padding-left: 10px">
        <v-col>
          <v-skeleton-loader
            v-if="loading == true"
            :height="180"
            :max-width="350"
            type="card-heading,card"
          ></v-skeleton-loader>
          <v-card v-else>
            <v-card-title primary class="justify-center" style="font-size: 14px"
              >Vibration X-Y-Z Axis(PPV)</v-card-title
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text>
              <SeismicChart
                :seismicSeries="seismicSeries"
                :height="180"
                :max-width="350"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row style="padding-left: 10px">
        <v-col>
          <v-card color="red" dark v-if="eventSeismic > 10">
            <v-card-title primary class="justify-center" style="font-size: 14px"
              >Total Vibration Breach #</v-card-title
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text v-else class="text-center" style="font-size: 25px">{{
              eventSeismic
            }}</v-card-text>
          </v-card>
          <v-card v-else>
            <v-card-title primary class="justify-center" style="font-size: 14px"
              >Total Vibration Breach #</v-card-title
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text v-else class="text-center" style="font-size: 25px">{{
              eventSeismic
            }}</v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row style="padding-left: 10px">
        <v-col>
          <v-card>
            <v-card-title class="justify-center" style="font-size: 15px"
              >Longest Vibration</v-card-title
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text v-else class="text-center" style="font-size: 25px"
              >{{ Math.max(...duration) }}
              <span style="font-size:15px">s</span></v-card-text
            >
          </v-card>
        </v-col>
      </v-row>
      <v-row style="padding-left: 10px">
        <v-col>
          <v-skeleton-loader
            v-if="loading == true"
            :height="180"
            :max-width="350"
            type="card-heading,card"
          ></v-skeleton-loader>
          <v-card v-else>
            <v-card-title primary class="justify-center" style="font-size: 14px"
              >Vibration Consolidated(PPV)</v-card-title
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text>
              <MagChart :magSeries="magSeries" :height="180" :max-width="350" />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row style="padding-left: 10px">
        <v-col>
          <v-card>
            <v-card-title class="justify-center" style="font-size: 15px"
              >Peak Vibration Detected</v-card-title
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text v-else class="text-center" style="font-size: 25px"
              >{{ Math.max(...mag) }}
              <span style="font-size:15px">mm/s</span></v-card-text
            >
          </v-card>
        </v-col>
      </v-row>

      <v-row style="padding-left: 10px">
        <v-col>
          <v-skeleton-loader
            v-if="loading == true"
            :height="180"
            :max-width="350"
            type="card-heading,card"
          ></v-skeleton-loader>
          <v-card v-else>
            <v-card-title primary class="justify-center" style="font-size: 14px"
              >Permanent Tilting</v-card-title
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text>
              <AngleChart
                :angleSeries="angleSeries"
                :height="180"
                :max-width="350"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row style="padding-left: 10px">
        <v-col>
          <v-card color="red" dark v-if="eventTilting > 10">
            <v-card-title primary class="justify-center" style="font-size: 14px"
              >Total Tilt Breach #</v-card-title
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text v-else class="text-center" style="font-size: 25px">{{
              eventTilting
            }}</v-card-text>
          </v-card>
          <v-card v-else>
            <v-card-title primary class="justify-center" style="font-size: 14px"
              >Total Tilt Breach #</v-card-title
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text v-else class="text-center" style="font-size: 25px">{{
              eventTilting
            }}</v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row style="padding-left: 10px">
        <v-col>
          <v-card>
            <v-card-title class="justify-center" style="font-size: 15px"
              >Worst Tilt Detected</v-card-title
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text v-else class="text-center" style="font-size: 25px"
              >{{ Math.max(...angle) }}
              <span style="font-size:15px">∠</span></v-card-text
            >
          </v-card>
        </v-col>
      </v-row>

      <v-row style="padding-left: 10px">
        <v-col>
          <v-skeleton-loader
            v-if="loading == true"
            :height="180"
            :max-width="350"
            type="card-heading,card"
          ></v-skeleton-loader>
          <v-card v-else>
            <v-card-title primary class="justify-center" style="font-size: 14px"
              >Noise Level</v-card-title
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text>
              <SoundChart
                :soundSeries="soundSeries"
                :height="180"
                :max-width="350"
              />
            </v-card-text>
            <v-row class="ma-0" justify="center">
              <v-col>
                <v-card class="pa-2" outlined tile>
                  <span primary style="font-size:10px" v-if="smp.length == 0"
                    >No Data</span
                  >
                  <span primary style="font-size:10px" v-else
                    >LAeq : {{ laeq[0].toFixed(2) }} dBA</span
                  >
                </v-card>
              </v-col>
              <v-col>
                <v-card class="pa-2" outlined tile>
                  <span primary style="font-size:10px" v-if="smp.length == 0"
                    >No Data</span
                  >
                  <span primary style="font-size:10px" v-else
                    >L10 : {{ l10[0].toFixed(2) }} dBA</span
                  >
                </v-card>
              </v-col>
              <v-col>
                <v-card class="pa-2" outlined tile>
                  <span primary style="font-size:10px" v-if="smp.length == 0"
                    >No Data</span
                  >
                  <span primary style="font-size:10px" v-else
                    >L90 : {{ l90[0].toFixed(2) }} dBA</span
                  >
                </v-card>
              </v-col>
              <v-col>
                <v-card class="pa-2" outlined tile>
                  <span primary style="font-size:10px" v-if="smp.length == 0"
                    >No Data</span
                  >
                  <span primary style="font-size:10px" v-else
                    >LAmin : {{ lmin[0].toFixed(2) }} dBA</span
                  >
                </v-card>
              </v-col>
              <v-col>
                <v-card class="pa-2" outlined tile>
                  <span primary style="font-size:10px" v-if="smp.length == 0"
                    >No Data</span
                  >
                  <span primary style="font-size:10px" v-else
                    >LAmax : {{ lmax[0].toFixed(2) }} dBA</span
                  >
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>

      <v-row style="padding-left: 10px">
        <v-col>
          <v-card color="red" dark v-if="eventSound > 10">
            <v-card-title primary class="justify-center" style="font-size: 14px"
              >Total Noise Breach #</v-card-title
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <p v-else class="text-center" style="font-size: 25px">
              {{ eventSound }}
            </p>
          </v-card>
          <v-card v-else>
            <v-card-title primary class="justify-center" style="font-size: 14px"
              >Total Noise Breach #</v-card-title
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text v-else class="text-center" style="font-size: 25px">{{
              eventSound
            }}</v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row style="padding-left: 10px">
        <v-col>
          <v-card>
            <v-card-title primary class="justify-center" style="font-size: 13px"
              >Recent Noise Lvl</v-card-title
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text v-else class="text-center" style="font-size: 25px"
              >{{ soundDb[0] }}
              <span style="font-size:15px">dBA</span></v-card-text
            >
          </v-card>
        </v-col>
      </v-row>

      <v-row style="padding-left: 10px">
        <v-col>
          <v-card>
            <v-card-title class="justify-center" style="font-size: 15px"
              >Peak Noise Lvl</v-card-title
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text v-else class="text-center" style="font-size: 25px"
              >{{ Math.max(...soundDb) }}
              <span style="font-size:15px">dBA</span></v-card-text
            >
          </v-card>
        </v-col>
      </v-row>

      <v-row style="padding-left: 10px">
        <v-col>
          <v-card>
            <v-card-title class="justify-center" style="font-size: 15px"
              >Longest Continuous Noise</v-card-title
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text v-else class="text-center" style="font-size: 25px"
              >{{ Math.max(...soundDura) }}
              <span style="font-size:15px">s</span></v-card-text
            >
          </v-card>
        </v-col>
      </v-row>

      <v-row style="padding-left: 10px">
        <v-col>
          <v-skeleton-loader
            v-if="loading == true"
            :height="180"
            :max-width="350"
            type="card-heading,card"
          ></v-skeleton-loader>
          <v-card v-else>
            <v-card-title primary class="justify-center" style="font-size: 14px"
              >Dust Level TSP: PM2.5</v-card-title
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text>
              <DensityChart
                :densitySeries="densitySeries"
                :height="180"
                :max-width="350"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row style="padding-left: 10px">
        <v-col>
          <v-card color="red" dark v-if="eventDensity > 10">
            <v-card-title primary class="justify-center" style="font-size: 14px"
              >Total TSP PM2.5 Breach #</v-card-title
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text v-else class="text-center" style="font-size: 25px">{{
              eventDensity
            }}</v-card-text>
          </v-card>
          <v-card v-else>
            <v-card-title primary class="justify-center" style="font-size: 14px"
              >Total TSP PM2.5 Breach #</v-card-title
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text v-else class="text-center" style="font-size: 25px">{{
              eventDensity
            }}</v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row style="padding-left: 10px">
        <v-col>
          <v-card>
            <v-card-title primary class="justify-center" style="font-size: 13px"
              >Recent TSP PM2.5</v-card-title
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text v-else class="text-center" style="font-size: 25px"
              >{{ density[0] }}
              <span style="font-size:15px">ug/m³</span></v-card-text
            >
          </v-card>
        </v-col>
      </v-row>

      <v-row style="padding-left: 10px">
        <v-col>
          <v-card>
            <v-card-title class="justify-center" style="font-size: 15px"
              >Peak TSP PM2.5</v-card-title
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text v-else class="text-center" style="font-size: 25px"
              >{{ Math.max(...density) }}
              <span style="font-size:15px">ug/m³</span></v-card-text
            >
          </v-card>
        </v-col>
      </v-row>

      <v-row style="padding-left: 10px">
        <v-col>
          <v-skeleton-loader
            v-if="loading == true"
            :height="180"
            :max-width="350"
            type="card-heading,card"
          ></v-skeleton-loader>
          <v-card v-else>
            <v-card-title primary class="justify-center" style="font-size: 14px"
              >Hazardous Gasses(CO,NH3,NO2)</v-card-title
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text>
              <CompoundChart
                :compoundSeries="compoundSeries"
                :height="180"
                :max-width="350"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row style="padding-left: 10px">
        <v-col>
          <v-card>
            <v-card-title primary class="justify-center" style="font-size: 13px"
              >Recent Hazardous Gasses</v-card-title
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text v-else class="text-center" style="font-size: 20px"
              >CO: {{ co[0] }}
              <span style="font-size:15px">mg/m³</span></v-card-text
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text v-else class="text-center" style="font-size: 20px"
              >NH3: {{ nh3[0] }}
              <span style="font-size:15px">mg/m³</span></v-card-text
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text v-else class="text-center" style="font-size: 20px"
              >NO2: {{ no2[0] }}
              <span style="font-size:15px">ug/m³</span></v-card-text
            >
          </v-card>
        </v-col>
      </v-row>

      <v-row style="padding-left: 10px">
        <v-col>
          <v-card>
            <v-card-title class="justify-center" style="font-size: 15px">
              Peak Hazardous Gasses
              <v-tooltip bottom style="z-index: 100">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" small
                    >mdi-information-outline</v-icon
                  >
                </template>
              <span>
                ⚪ Threshold level for Carbon Monoxide(CO) is 30 mg/m³
                <br />
                ⚪ Threshold level for Ammonia(NH3) is 1.5 mg/m³
                <br />
                ⚪ Threshold level for Nitrogen Dioxide(NO2) is 280 ug/m³
              </span>
              </v-tooltip>
            </v-card-title>
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text v-else class="text-center" style="font-size: 20px"
              >CO: {{ Math.max(...co) }}
              <span style="font-size:15px">mg/m³</span></v-card-text
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text v-else class="text-center" style="font-size: 20px"
              >NH3: {{ Math.max(...nh3) }}
              <span style="font-size:15px">mg/m³</span></v-card-text
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text v-else class="text-center" style="font-size: 20px"
              >NO2: {{ Math.max(...no2) }}
              <span style="font-size:15px">ug/m³</span></v-card-text
            >
          </v-card>
        </v-col>
      </v-row>

      <v-row style="padding-left: 10px">
        <v-col style="padding-left:10px">
          <v-card>
            <v-card-title class="justify-center" style="font-size: 15px"
              >Minimum Hazardous Gasses</v-card-title
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text v-else class="text-center" style="font-size: 20px"
              >CO: {{ Math.min(...co) }}
              <span style="font-size:15px">mg/m³</span></v-card-text
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text v-else class="text-center" style="font-size: 20px"
              >NH3: {{ Math.min(...nh3) }}
              <span style="font-size:15px">mg/m³</span></v-card-text
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text v-else class="text-center" style="font-size: 20px"
              >NO2: {{ Math.min(...no2) }}
              <span style="font-size:15px">ug/m³</span></v-card-text
            >
          </v-card>
        </v-col>
      </v-row>

      <v-row style="padding-left: 10px">
        <v-col>
          <v-skeleton-loader
            v-if="loading == true"
            :height="180"
            :max-width="350"
            type="card-heading,card"
          ></v-skeleton-loader>
          <v-card v-else>
            <v-card-title primary class="justify-center" style="font-size: 14px"
              >Ambient Temperature</v-card-title
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text>
              <TempChart
                :tempSeries="tempSeries"
                :height="180"
                :max-width="350"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row style="padding-left: 10px">
        <v-col>
          <v-card color="red" dark v-if="eventTemp > 10">
            <v-card-title primary class="justify-center" style="font-size: 14px"
              >Total Temp Breach #</v-card-title
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text v-else class="text-center" style="font-size: 25px">{{
              eventTemp
            }}</v-card-text>
          </v-card>
          <v-card v-else>
            <v-card-title primary class="justify-center" style="font-size: 14px"
              >Total Temp Breach #</v-card-title
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text v-else class="text-center" style="font-size: 25px">{{
              eventTemp
            }}</v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row style="padding-left: 10px">
        <v-col>
          <v-card>
            <v-card-title primary class="justify-center" style="font-size: 13px"
              >Recent Temperature</v-card-title
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text v-else class="text-center" style="font-size: 25px"
              >{{ temp[0] }} <span style="font-size:15px">°C</span></v-card-text
            >
          </v-card>
        </v-col>
      </v-row>

      <v-row style="padding-left: 10px">
        <v-col>
          <v-card>
            <v-card-title class="justify-center" style="font-size: 15px"
              >Peak Temperature</v-card-title
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text v-else class="text-center" style="font-size: 25px"
              >{{ Math.max(...temp) }}
              <span style="font-size:15px">°C</span></v-card-text
            >
          </v-card>
        </v-col>
      </v-row>

      <v-row style="padding-left: 10px">
        <v-col>
          <v-card>
            <v-card-title class="justify-center" style="font-size: 15px"
              >Lowest Temperature</v-card-title
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text v-else class="text-center" style="font-size: 25px"
              >{{ Math.min(...temp) }}
              <span style="font-size:15px">°C</span></v-card-text
            >
          </v-card>
        </v-col>
      </v-row>

      <v-row style="padding-left: 10px">
        <v-col>
          <v-skeleton-loader
            v-if="loading == true"
            :height="180"
            :max-width="350"
            type="card-heading,card"
          ></v-skeleton-loader>
          <v-card v-else>
            <v-card-title primary class="justify-center" style="font-size: 14px"
              >Ambient Relative Humidity</v-card-title
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text>
              <HumidChart
                :humidSeries="humidSeries"
                :height="180"
                :max-width="350"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row style="padding-left: 10px">
        <v-col>
          <v-card color="red" dark v-if="eventHumid > 10">
            <v-card-title primary class="justify-center" style="font-size: 14px"
              >Total Humidity Breach #</v-card-title
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text v-else class="text-center" style="font-size: 25px">{{
              eventHumid
            }}</v-card-text>
          </v-card>
          <v-card v-else>
            <v-card-title primary class="justify-center" style="font-size: 14px"
              >Total Humidity Breach #</v-card-title
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text v-else class="text-center" style="font-size: 25px">{{
              eventHumid
            }}</v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row style="padding-left: 10px">
        <v-col>
          <v-card>
            <v-card-title primary class="justify-center" style="font-size: 13px"
              >Recent Humidity</v-card-title
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text v-else class="text-center" style="font-size: 25px"
              >{{ humid[0] }}
              <span style="font-size:15px">%RH</span></v-card-text
            >
          </v-card>
        </v-col>
      </v-row>

      <v-row style="padding-left: 10px">
        <v-col>
          <v-card>
            <v-card-title class="justify-center" style="font-size: 15px"
              >Peak Humidity</v-card-title
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text v-else class="text-center" style="font-size: 25px"
              >{{ Math.max(...humid) }}
              <span style="font-size:15px">%RH</span></v-card-text
            >
          </v-card>
        </v-col>
      </v-row>

      <v-row style="padding-left: 10px">
        <v-col>
          <v-card>
            <v-card-title class="justify-center" style="font-size: 15px"
              >Lowest Humidity</v-card-title
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text v-else class="text-center" style="font-size: 25px"
              >{{ Math.min(...humid) }}
              <span style="font-size:15px">%RH</span></v-card-text
            >
          </v-card>
        </v-col>
      </v-row>

      <v-card-title>Equipment Properties</v-card-title>
      <v-row style="padding-left: 10px">
        <v-col>
          <v-skeleton-loader
            v-if="loading == true"
            :height="180"
            :max-width="350"
            type="card-heading,card"
          ></v-skeleton-loader>
          <v-card v-else>
            <v-card-title primary class="justify-center" style="font-size: 14px"
              >Power</v-card-title
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text>
              <BattChart
                :battSeries="battSeries"
                :height="180"
                :max-width="350"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row style="padding-left: 10px">
        <v-col>
          <v-card>
            <v-card-title class="justify-center" style="font-size: 15px"
              >Tamper Switch</v-card-title
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text v-else class="text-center" style="font-size: 25px">{{
              eventTamper
            }}</v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row style="padding-left: 10px">
        <v-col>
          <v-card>
            <v-card-title class="justify-center" style="font-size: 15px"
              >Solar Power</v-card-title
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text v-else class="text-center" style="font-size: 25px"
              >{{ (vsolar[0] / 1000).toFixed(2) }}
              <span style="font-size:15px">V</span></v-card-text
            >
          </v-card>
        </v-col>
      </v-row>
      <v-row style="padding-left: 10px">
        <v-col>
          <v-card>
            <v-card-title class="justify-center" style="font-size: 15px"
              >Battery Power</v-card-title
            >
            <v-card-text
              v-if="smp.length == 0"
              class="text-center"
              style="font-size: 20px"
              >No Data</v-card-text
            >
            <v-card-text v-else class="text-center" style="font-size: 25px"
              >{{ (vbatt[0] / 1000).toFixed(2) }}
              <span style="font-size:15px">V</span></v-card-text
            >
          </v-card>
        </v-col>
      </v-row>

      <v-card-title>Logs</v-card-title>
      <div style="padding-left: 10px">
        <v-card>
          <v-simple-table height="300px">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Date
                  </th>
                  <th class="text-left">
                    Time
                  </th>
                  <th class="text-left">
                    X-axis
                  </th>
                  <th class="text-left">
                    Y-axis
                  </th>
                  <th class="text-left">
                    Z-axis
                  </th>
                  <th class="text-left">
                    Δ° Tilt
                  </th>
                  <th class="text-left">
                    Vibration (PPV)
                  </th>
                  <th class="text-left">
                    Noise
                  </th>
                  <th class="text-left">
                    Noise Dura.
                  </th>
                  <th class="text-left">
                    Amb. Temp
                  </th>
                  <th class="text-left">
                    Amb. Humid
                  </th>
                  <th class="text-left">
                    Dust(TSP)
                  </th>
                  <th class="text-left">
                    Gas CO
                  </th>
                  <th class="text-left">
                    Gas NH3
                  </th>
                  <th class="text-left">
                    Gas NO2
                  </th>
                  <th class="text-left">
                    Batt. (V)
                  </th>
                  <th class="text-left">
                    Solar (V)
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in smp" :key="i">
                  <td>{{ formatDateTd(item.timestamp) }}</td>
                  <td>{{ formatTimeTd(item.timestamp) }}</td>
                  <td>{{ item.fields.seismic_data.x.toFixed(4) }} mm/s</td>
                  <td>{{ item.fields.seismic_data.y.toFixed(4) }} mm/s</td>
                  <td>{{ item.fields.seismic_data.z.toFixed(4) }} mm/s</td>
                  <td>{{ item.fields.seismic_data.angle }}°</td>
                  <td>{{ item.fields.seismic_data.mag }} mm/s</td>
                  <td>{{ item.fields.sound_data.sound }} dBA</td>
                  <td>{{ item.fields.sound_data.evt_duration }} s</td>
                  <td v-if="item.fields.weather_data.amb_temp == 0">N/A</td>
                  <td v-else>{{ item.fields.weather_data.amb_temp }} °C</td>
                  <td v-if="item.fields.weather_data.humidity == 0">N/A</td>
                  <td v-else>{{ item.fields.weather_data.humidity }} %RH</td>
                  <td>{{ item.fields.air_quality_data.density }} ug/m³</td>
                  <td v-if="item.fields.air_quality_data.co == 0">N/A</td>
                  <td v-else>{{ item.fields.air_quality_data.co }} mg/m³</td>
                  <td v-if="item.fields.air_quality_data.nh3 == 0">N/A</td>
                  <td v-else>{{ item.fields.air_quality_data.nh3 }} mg/m³</td>
                  <td v-if="item.fields.air_quality_data.no2 == 0">N/A</td>
                  <td v-else>{{ item.fields.air_quality_data.no2 }} ug/m³</td>
                  <td>
                    {{ (item.fields.power_data.vbatt_ext / 1000).toFixed(2) }} v
                  </td>
                  <td>
                    {{ (item.fields.power_data.vsolar / 1000).toFixed(2) }} v
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </div>
      <br />
    </v-container>
  </div>
</template>

<script>
  import Vue from "vue";
  import moment from "moment";
  import HereMap from "../components/HereMapOverview.vue";
  import SeismicChart from "../components/SeismicChart.vue";
  import MagChart from "../components/MagChart.vue";
  import AngleChart from "../components/AngleChart.vue";
  import SoundChart from "../components/SoundChart.vue";
  import TempChart from "../components/TempChart.vue";
  import HumidChart from "../components/HumidChart.vue";
  import DensityChart from "../components/DensityChart.vue";
  import CompoundChart from "../components/CompoundChart.vue";
  import BattChart from "../components/BattChart.vue";
  import VueApexCharts from "vue-apexcharts";

  Vue.component("apexchart", VueApexCharts);

  export default {
    props: {
      seismicSeries: Array,
      magSeries: Array,
      angleSeries: Array,
      soundSeries: Array,
      tempSeries: Array,
      humidSeries: Array,
      densitySeries: Array,
      compoundSeries: Array,
      battSeries: Array,
      smp: Array,
      latitude: Array,
      longitude: Array,
      duration: Array,
      mag: Array,
      angle: Array,
      soundDb: Array,
      soundDura: Array,
      density: Array,
      co: Array,
      nh3: Array,
      no2: Array,
      temp: Array,
      humid: Array,
      vsolar: Array,
      vbatt: Array,
      laeq: Array,
      lmin: Array,
      lmax: Array,
      l10: Array,
      l90: Array,
      smpEvent: Array,
      event: Array,
      renderComponent: Boolean,
      loading: Boolean,
    },
    components: {
      HereMap,
      SeismicChart,
      MagChart,
      AngleChart,
      SoundChart,
      TempChart,
      HumidChart,
      DensityChart,
      CompoundChart,
      BattChart,
    },
    computed: {
      eventSeismic() {
        var event = this.smpEvent;
        var a = event.filter(function(value) {
          return value === 13;
        }).length;
        var b = event.filter(function(value) {
          return value === 16;
        }).length;
        return a + b;
      },
      eventTilting() {
        var event = this.smpEvent;
        var a = event.filter(function(value) {
          return value === 14;
        }).length;
        var b = event.filter(function(value) {
          return value === 15;
        }).length;
        var c = event.filter(function(value) {
          return value === 29;
        }).length;
        return a + b + c;
      },
      eventSound() {
        var event = this.smpEvent;
        var a = event.filter(function(value) {
          return value === 19;
        }).length;
        var b = event.filter(function(value) {
          return value === 20;
        }).length;
        return a + b;
      },
      eventGas() {
        var co = this.coEvent;
        var nh3 = this.nh3Event;
        var no2 = this.no2Event;
        var a = co.filter(function(value) {
          return value > 30;
        }).length;
        var b = nh3.filter(function(value) {
          return value > 1.5;
        }).length;
        var c = no2.filter(function(value) {
          return value > 280;
        }).length;
        return a + b + c;
      },
      eventTemp() {
        var event = this.temp;
        var a = event.filter(function(value) {
          return value > 45;
        }).length;
        return a;
      },
      eventHumid() {
        var event = this.humid;
        var a = event.filter(function(value) {
          return value > 99;
        }).length;
        return a;
      },
      eventDensity() {
        var event = this.smpEvent;
        var a = event.filter(function(value) {
          return value === 22;
        }).length;
        return a;
      },
      eventTamper() {
        var event = this.smp;
        var a = event.map(sts => sts.fields.tmper_sts);
        var b = a[0];
        if (b == 0) {
          return "Close";
        } else {
          return "Open";
        }
      },
    },
    methods: {
      darkMode() {
        this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      },
      eventDesc(
        value,
        mag,
        angle,
        soundDb,
        duration_sound,
        density,
        co,
        noTwo,
        nhThree,
        temp,
        humid
      ) {
        var velo = mag;
        var tilt = angle;
        var noise = soundDb;
        var soundDura = duration_sound;
        var dust = density;
        var cbnDxd = co;
        var ntgDxd = noTwo;
        var amnia = nhThree;
        var tempe = temp;
        var humidi = humid;
        switch (value) {
          case 13:
            return `Peak Vibration Level : ${velo} mm/s. Max ALLOWED is 5.0mm/s..`;
          case 14:
            return `Permanent tilting detected: ${tilt}° from previous position`;
          case 15:
            return `Severe tilting detected: ${tilt}° from previous position`;
          case 16:
            return "Peak Particles Velocity(PPV) continuously > ALLOWED 5.0 mm/s for 1m 20sec.";
          case 17:
            return "Unit enclosure is OPENED!";
          case 18:
            return `Noise level > ALLOWED 80 dBa and lasted OVER ${soundDura} seconds limit`;
          case 19:
            return `Noise Peak Level: ${noise} dBa. Limit is 90 dBa(7am-7pm) & 85 dBa(7pm-7am).`;
          case 21:
            return `Noise Continuous Breached at ${noise} dBa. Duration recorded: ${soundDura} secs.`;
          case 22:
            return `Dust PM2.5, Total Suspended Particles (TSP) PEAK: ${dust} ug/m3.`;
          case 29:
            return `Permanent tilting detected: ${tilt}° from previous position`;
          case 31:
            return "Unit enclosure is CLOSED!";
          default:
            if (cbnDxd > 30) {
              return `Carbon Monoxide (CO) Level: ${cbnDxd}mg/m. Threshold is 30mg/m3.`;
            } else if (ntgDxd > 280) {
              return `Nitrogen Dioxide (NO2) Level: ${ntgDxd}µg/m3. Threshold is 280µg/m3.`;
            } else if (amnia > 1.5) {
              return `Ammonia (NH3) Level: ${amnia}mg/m. Threshold is 1.5mg/m3.`;
            } else if (tempe > 45) {
              return `Ambient Temperature: ${tempe}°C. Threshold is 45°C.`;
            } else if (humidi > 99) {
              return `Humidity: ${humidi}%RH. Threshold is 99%RH.`;
            }
        }
      },
      map(lat, lon) {
        return (this.center = {
          lat: lat,
          lng: lon,
        });
      },
      formatDateTd(value) {
        return moment(value).format("DD MMM YY");
      },
      formatTime(value) {
        return moment(value).format("H:mm:ss");
      },
      formatTimeTd(value) {
        return moment(value).format("H:mm:ss");
      },
      formatDay(value) {
        return moment(value).format("DD");
      },
      formatMonth(value) {
        return moment(value).format("MMMM");
      },
    },
  };
</script>

<style scoped>
  table,
  th,
  td {
    border: 2px groove;
  }
  th {
    background-color: rgb(213, 205, 205);
    position: sticky;
    top: 0;
  }
</style>
